if (!customElements.get('type-group-picker')) {
  customElements.define(
    'type-group-picker',
    class TypeGroupPicker extends HTMLElement {
      connectedCallback() {
        this.abortController = null;
        this.addEventListener('change', this.onTypeChange.bind(this));
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      onTypeChange(event) {
        const input = event.target;
        if (!input.matches('input[type="radio"]')) return;
        // Already on this product — do nothing
        if (input.value === this.dataset.productHandle) return;
        this.loadProduct(input.value, input.dataset.productUrl);
      }

      loadProduct(handle, productUrl) {
        const sectionId = this.dataset.section;
        const sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionWrapper) return;

        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();

        sectionWrapper.style.opacity = '0.5';
        sectionWrapper.style.pointerEvents = 'none';
        sectionWrapper.setAttribute('aria-busy', 'true');

        fetch(`/products/${handle}?section_id=${sectionId}`, {
          signal: this.abortController.signal,
        })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            sectionWrapper.innerHTML = parsed.body.innerHTML;
            sectionWrapper.style.opacity = '';
            sectionWrapper.style.pointerEvents = '';
            sectionWrapper.removeAttribute('aria-busy');
            history.pushState({}, '', productUrl || `/products/${handle}`);
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            console.error('[type-group-picker] Failed to load product:', error);
            sectionWrapper.style.opacity = '';
            sectionWrapper.style.pointerEvents = '';
            sectionWrapper.removeAttribute('aria-busy');
            // Graceful fallback: navigate normally
            window.location.href = productUrl || `/products/${handle}`;
          });
      }
    },
  );
}
